/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";

// Import Swiper styles
import 'swiper/swiper.min.css';
import './UserShopsPopularSlider.scss';

import { Container, Box, Grid } from "@mui/material";

import UserSellerShop from "components/elements/user/shops/UserSellerShop";
import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";
import {isFeatureSupported} from "helpers/utils";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";


const UserShopsPopularSlider = (props) => {

  const {
      popularshops, userMainAddStoreToFavlist, userMainGetPopularStoreList, isLoading, marketId, includeHeader
  } = props;
  const { shops } = popularshops;

    useEffect(() => {
        userMainGetPopularStoreList(marketId);
    }, []);

    const breakpoints = {
        300: {
            slidesPerView: 2.0,
            spaceBetween: 20,
        },
        340: {
            slidesPerView: 2.2,
            spaceBetween: 20,
        },
        380: {
            slidesPerView: 2.4,
            spaceBetween: 20,
        },
        420: {
            slidesPerView: 2.6,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 2.8,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };

    const renderResults = () => (
        <Container mt={2}>
            {includeHeader && <CustomSectionCreator icon={<TrendingUpIcon sx={{ color: '#E53E3E', mr: 1 }} />} title={'Popular ' + process.env.REACT_APP_SHOP_TITLE} seeLink="/shops/sort/popular" seeMoreLinkTitle={isFeatureSupported("shopreels") ? "View more" : "View more"} seeMoreLink={isFeatureSupported("shopreels") ? "/shops/sort/popular?ls=1" : "/shops/sort/popular"} />}
            <swiper-container slides-per-view="1.8" space-between="4" free-mode="true" breakpoints={JSON.stringify(breakpoints)}>
                { shops.map((shop, index) => (
                    <swiper-slide key={index}>
                        <Box sx={{ width: 150 }}>
                        <UserSellerShop
                            shop={shop}
                            isDirect={true}
                            linkArrow={isFeatureSupported("shopreels") ? "/shops/sort/popular?ls=1&li=" + index : ""}
                            linkMain={"/shops/sort/popular?ls=2&li=" + index}
                            onAddToFavlistClicked={() => userMainAddStoreToFavlist(shop)}
                            key={`${index + 1}`}
                        />
                        </Box>
                    </swiper-slide>
                ))}
            </swiper-container>
        </Container>
    );

  return (
<>
      {isLoading ? <MockProductBox />
              : shops.length > 0
                  ? renderResults()
                  : ""}

</>

  );
};

UserShopsPopularSlider.propTypes = {
    popularshops: PropTypes.objectOf(PropTypes.any).isRequired,
    userMainGetPopularStoreList: PropTypes.func.isRequired,
    userMainAddStoreToFavlist: PropTypes.func.isRequired,
};

// Mapping Props and State.
const userShopsPopularSlider = connect(
  ({ userMainShops, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
      popularshops: userMainShops.popularshops,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserShopsPopularSlider);

export { userShopsPopularSlider as default };
